import { makeQuery } from "../makeQuery";

export const useQuerySkills = makeQuery<unknown[]>("/api/chat/skills");
